/**
 * Syncs A–Z letter buttons with the vendor brands Swiper inside [data-vendor-mega-root].
 * Depends on slider.js + Swiper (already loaded globally).
 */

function bindVendorMegaRoot(root) {
  if (root.dataset.vendorMegaBound === '1') return;
  root.dataset.vendorMegaBound = '1';

  const setActiveButton = (index) => {
    root.querySelectorAll('[data-brand-nav-slide-index]').forEach((btn) => {
      const idx = parseInt(btn.dataset.brandNavSlideIndex, 10);
      btn.classList.toggle('brands-nav__letter--active', idx === index);
    });
  };

  const attach = (sw) => {
    sw.on('slideChange', () => {
      setActiveButton(sw.activeIndex);
    });
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-brand-nav-slide-index]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      const idx = parseInt(btn.dataset.brandNavSlideIndex, 10);
      if (Number.isNaN(idx)) return;
      sw.slideTo(idx);
    });
  };

  let frames = 0;
  const maxFrames = 600;
  const tick = () => {
    const swiperEl = root.querySelector('.slider-block-swiper');
    const sw = swiperEl?.swiper;
    if (sw) {
      attach(sw);
      setActiveButton(sw.activeIndex);
      return;
    }
    frames += 1;
    if (frames < maxFrames) requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
}

function initVendorMegaSliders() {
  document.querySelectorAll('[data-vendor-mega-root]').forEach(bindVendorMegaRoot);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVendorMegaSliders);
} else {
  initVendorMegaSliders();
}

document.addEventListener('shopify:section:load', initVendorMegaSliders);

/** Mega menus are hidden until <details> opens; refresh Swiper layout when any details opens. */
document.addEventListener(
  'toggle',
  (e) => {
    if (!(e.target instanceof HTMLDetailsElement) || !e.target.open) return;
    const section = e.target.closest('[id^="shopify-section-"]');
    section?.querySelectorAll('[data-vendor-mega-root] .slider-block-swiper').forEach((el) => {
      el.swiper?.update();
    });
  },
  true
);
